import { useCustom } from "@refinedev/core";

export interface KlantDetail {
  id: number;
  naam: string;
  email: string | null;
  telefoon: string | null;
  mobiel: string | null;
  straat: string | null;
  huisnummer: string | null;
  toevoeging: string | null;
  postcode: string | null;
  woonplaats: string | null;
}

/** Compose the address line from a klant detail (street + number + addition, postcode + city). */
export function addressLine(d: KlantDetail | null): string {
  if (!d) return "";
  const street = [d.straat, [d.huisnummer, d.toevoeging].filter(Boolean).join("")].filter(Boolean).join(" ");
  const city = [d.postcode, d.woonplaats].filter(Boolean).join(" ");
  return [street, city].filter(Boolean).join(", ");
}

/**
 * Finder / owner contact panel for the intake terms steps (Jmix "Gegevens vinder/eigenaar": Naam,
 * adres, telefoon, e-mail). Fetches the relation's full contact details by id; renders nothing extra
 * when no relation is selected.
 */
export function RelationContactPanel({
  klantId,
  label,
  t,
  urlBase = "intake/reference/klanten",
}: {
  klantId: number | null;
  label: string;
  t: (k: string) => string;
  // The klant-detail feed base; the release wizard points at "release/reference/klanten" so a
  // release-only operator (no intake authority) can still load the contact panel.
  urlBase?: string;
}) {
  const { data } = useCustom<KlantDetail>({
    url: `${urlBase}/${klantId}`,
    method: "get",
    queryOptions: { enabled: klantId != null },
  });
  const d = (data?.data as KlantDetail | undefined) ?? null;
  const address = addressLine(d);
  const phone = [d?.telefoon, d?.mobiel].filter(Boolean).join(" / ");

  return (
    <div className="fawkes-inboeken__contact">
      <span className="fui-field__label">{label}</span>
      {klantId == null ? (
        <span className="fawkes-inboeken__muted">{t("inboeken.relation.none")}</span>
      ) : (
        <div className="fawkes-inboeken__contact-body">
          <span className="fawkes-inboeken__contact-name">{d?.naam ?? `#${klantId}`}</span>
          {address && <span>{address}</span>}
          {phone && <span>{phone}</span>}
          {d?.email && <span>{d.email}</span>}
        </div>
      )}
    </div>
  );
}
